<template>
  <WdsStack v-if="!loading && terminatedAt !== ''" direction-column class="tw-px-2">
    <WdsStack justify-space-between>
      <WdsText>
        {{ $t('Contract terminated on :date', { date: terminatedAt }) }}
      </WdsText>
    </WdsStack>
    <WdsText secondary>
      <div class="tw-font-normal">
        {{
          $t(
            (isWorker || (isRecruiter && hasRecruiterManagingWorkers))
              ? 'The contract was terminated early. You may still submit payment requests within the adjusted contract period.'
              : hasRecruiterManagingWorkers
                ? 'The contract was terminated early. The staffing agency may still submit payment requests within the adjusted contract period.'
                : 'The contract was terminated early. The worker may still submit payment requests within the adjusted contract period.',
          )
        }}
      </div>
    </WdsText>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsStack, WdsText } from '@worksome/wds-components'
import { useQuery } from '@vue/apollo-composable'
import { useHireRecruiter } from '../composables/useHireRecruiter'
import { graphql } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import useDate from '@/composables/useDate'
import { useAccountCapabilities } from '@/composables/useAccountCapabilities'

const props = defineProps<{
  hireId: string
}>()

const { isWorker, isRecruiter } = useAccountCapabilities()
const { hasRecruiterManagingWorkers } = useHireRecruiter(props.hireId)

const { result, loading } = useQuery(
  graphql(`
    query HireTerminatedStatus($id: ID!) {
      hire(id: $id) {
        activeContract {
          endDate
        }
      }
    }
  `),
  {
    id: props.hireId,
  },
  {
    clientId: 'publicApi',
  },
)

const hire = computed(() => result.value?.hire)

const terminatedAt = computed(() => {
  if (!hire.value?.activeContract?.endDate) return ''
  return useDate(hire.value.activeContract.endDate, 'MMM DD, YYYY').date.value
})
</script>
